import React from 'react';
import T from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { VIEWS } from 'workflow/constants/newInbox';

import { colorBlue1 } from 'styles/_colors.scss';
import styles from './BackToDetail.scss';

const BackToDetail = ({ changeView }) => {
    return (
        <div className={styles.BackToDetail} onClick={() => changeView(VIEWS.TASK_DETAIL)} data-cy="BackToDetail">
            <ArrowBackIcon style={{ color: colorBlue1 }} />
            <span className={styles.BackToDetail__Text}>Back to Detail</span>
        </div>
    );
};

BackToDetail.propTypes = {
    changeView: T.func.isRequired
};

export default BackToDetail;
